/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Solid_Liger_CatchInputs */

const fr_flat_solid_liger_catch = /** @type {(inputs: Flat_Solid_Liger_CatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner un produit`)
};

/**

* @param {Flat_Solid_Liger_CatchInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const flat_solid_liger_catch = /** @type {((inputs?: Flat_Solid_Liger_CatchInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Solid_Liger_CatchInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_flat_solid_liger_catch(inputs)
});